import { useUnitOptionsGet } from '@sbv-clients/data-access-api';
import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const dataFetcher = useUnitOptionsGet;
type ExtraParameters = Parameters<typeof dataFetcher>[0];
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({
  facilityId: props.facilityId,
  includeCensus: props.includeCensus,
  filteredByOpeningTemplates: props.filteredByOpeningTemplates,
});

export const {
  UnitSelectField,
  UnitFormSelectField,
  UnitDataGridSelectField,
  UnitIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'Unit',
  useOptionsHook: useUnitOptionsGet,
  extractHookParams: hookParamsGetter,
  useLabelHook: () => useProLaborLevelDesignations().UnitLaborLevel,
});
